(() => {
  const script = document.currentScript;
  const subscriptionTemplate = script?.dataset.subscriptionSummary || '';
  const oneTimeTemplate = script?.dataset.oneTimeSummary || '';

  function boot(root = document) {
    root.querySelectorAll('.collections-template__nav-item').forEach((button) => {
      if (button.dataset.eleatNavReady) return;
      button.dataset.eleatNavReady = 'true';
      const sync = () => {
        const label = button.textContent.trim();
        if (button.getAttribute('role') !== 'button') button.setAttribute('role', 'button');
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      };
      new MutationObserver(sync).observe(button, {attributes: true, attributeFilter: ['role', 'aria-label']});
      sync();
    });

    root.querySelectorAll('.product-template__flavour-cta').forEach((button) => {
      if (button.dataset.eleatSummaryReady) return;
      const section = button.closest('.shopify-section');
      const group = section?.querySelector('.product-template__plan[role="radiogroup"]');
      if (!group) return;
      button.dataset.eleatSummaryReady = 'true';
      const summary = document.createElement('p');
      summary.className = 'eleat-purchase-summary';
      summary.id = `${section.id}-purchase-summary`;
      summary.setAttribute('aria-live', 'polite');
      summary.setAttribute('aria-atomic', 'true');
      button.before(summary);
      button.setAttribute('aria-describedby', [button.getAttribute('aria-describedby'), summary.id].filter(Boolean).join(' '));

      const sync = () => {
        const active = group.querySelector('.product-template__plan-option.active');
        const price = active?.querySelector('.plan-option__price')?.textContent.trim() || '';
        const oneTime = (active?.dataset.purchaseType || '').toLowerCase().includes('one');
        const details = active?.querySelector('.plan-option__purchase-note')?.textContent.trim()
          || active?.querySelector('.plan-option__details li')?.textContent.trim() || '';
        const quantity = active?.dataset.quantity || '';
        const template = oneTime ? oneTimeTemplate : subscriptionTemplate;
        const copy = /\d/.test(price) && /[£$€]/.test(price)
          ? template.replace('[price]', price).replace('[details]', details).replace('[quantity]', quantity)
          : '';
        if (summary.textContent !== copy) summary.textContent = copy;
        summary.hidden = !copy;
      };
      new MutationObserver(sync).observe(group, {
        attributes: true, attributeFilter: ['class', 'data-plan-price'],
        childList: true, characterData: true, subtree: true
      });
      sync();
    });

    root.querySelectorAll('.product-faqs__faq').forEach((faq, index) => {
      const button = faq.querySelector('.product-faqs__faq-question');
      const answer = faq.querySelector('.product-faqs__faq-answer');
      if (!button || !answer || button.dataset.eleatFaqReady) return;
      button.dataset.eleatFaqReady = 'true';
      const sectionId = faq.closest('.shopify-section')?.id || 'eleat-faqs';
      answer.id ||= `${sectionId}-answer-${index}`;
      button.type = 'button';
      button.setAttribute('aria-controls', answer.id);
      const sync = () => button.setAttribute('aria-expanded', String(getComputedStyle(answer).display !== 'none'));
      new MutationObserver(sync).observe(answer, {attributes: true, attributeFilter: ['class', 'style', 'hidden']});
      sync();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
